import React from "react";
import { Box, Card, CardContent, Typography, LinearProgress } from "@mui/material";

export default function CreditScoreFactors({ data }) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" mb={2}>
          Credit Score Factors
        </Typography>

        {data.map((factor, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">
              {factor.name} – {factor.impact}%
            </Typography>
            <LinearProgress
              variant="determinate"
              value={factor.score}
              sx={{
                height: 8,
                borderRadius: 4,
                mt: 0.5,
                bgcolor: "grey.800",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: factor.color || "primary.main",
                },
              }}
            />
            <Typography variant="caption" color="text.secondary">
              Score: {factor.score}/100 • Rating: {factor.rating}
            </Typography>
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}
